import {
  DataGroupApiGetDataGroupsSensitivityRequest,
  DataGroupSensitivityResponse,
  UserDataGroupsResponse,
} from '@ariksa/abac/api';
import {
  AccessRequestCreateResponse,
  ItemApiGetSnowflakePrivilegeCatalogRequest,
  JitDataGroupStatusesResponse,
  SnowflakePrivilegeCatalogResponse,
} from '@ariksa/jit';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { Abac, JitService } from 'api/services';

import { actions } from './slice';

export function* dataCatalogSaga() {
  yield takeLatestAction(actions.getDataGroups, doGetDataGroups);
  yield takeLatestAction(
    actions.getDataGroupsSensitivity,
    doGetDataGroupsSensitivity,
  );
  yield takeLatestAction(actions.getDataGroupStatuses, doGetDataGroupStatuses);
  yield takeLatestAction(actions.createRequest, doCreateRequest);
  yield takeLatestAction(actions.getPrivilegeCatalog, doGetPrivilegeCatalog);
}

export function* doGetDataGroups(ctx: QueryContext<UserDataGroupsResponse>) {
  yield call(ctx.fetch, () => Abac.DataGroup.listMyDataGroups(ctx.params));
}

// Fetches sensitivity for all catalog data groups in a single bulk request.
function* doGetDataGroupsSensitivity(
  ctx: QueryContext<
    DataGroupSensitivityResponse[],
    DataGroupApiGetDataGroupsSensitivityRequest
  >,
) {
  yield call(ctx.fetch, () =>
    Abac.DataGroup.getDataGroupsSensitivity(ctx.params),
  );
}

function* doGetDataGroupStatuses(
  ctx: QueryContext<JitDataGroupStatusesResponse>,
) {
  yield call(ctx.fetch, () => JitService.Jit.getMyDataGroupStatuses());
}

function* doCreateRequest(ctx: QueryContext<AccessRequestCreateResponse>) {
  yield call(ctx.fetch, () =>
    JitService.Jit.createRequest({
      accessRequestCreateRequest: ctx.params,
    }),
  );
}

function* doGetPrivilegeCatalog(
  ctx: QueryContext<
    SnowflakePrivilegeCatalogResponse,
    ItemApiGetSnowflakePrivilegeCatalogRequest
  >,
) {
  yield call(ctx.fetch, () =>
    JitService.Jit.getSnowflakePrivilegeCatalog(ctx.params),
  );
}
